(function () {
	'use strict';

	angular
        .module('app')
        .service('loginService', loginService);

	loginService.$inject = ['$http'];

	function loginService($http) {
		/* jshint validthis:true */
		var vm = this;
		var baseUrl = '/api/login';

		vm.login = login;
		vm.logout = logout;

		function login(model) {
			return $http.post(baseUrl, model, { cache: false });
		}

		function logout() {
			return $http.get(baseUrl, { cache: false });
		}
	}
})();